import React, { Component } from 'react'
import { Layout, PageHeader } from 'antd'
import List from '@components/NotifiactionsList'
import FilterBar from './FilterBar'

export default class Notifications extends Component<any, any> {
    render() {
        return (
            <Layout>
                <PageHeader
                    onBack={() => window.history.back()}
                    title="התראות"
                    subTitle="רשימת כל התראות המערכת והפניות מהלקוחות"
                />
                <FilterBar />
                <List filters={{}} />
            </Layout>
        )
    }
}
